import config from './config';
import axios from 'axios';
import router from '../router'
import qs from 'qs';
import store from '.././store/index'
// axios 配置
axios.defaults.timeout = 500000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.withCredentials = true;
var authorization = getCookie('authorization');
axios.defaults.headers.common['authorization'] = authorization;
//Axios实现请求重试
axios.defaults.retry = 1; //重试次数
axios.defaults.retryDelay = 1000; //重试延时
axios.defaults.shouldRetry = (error) => true; //重试条件，默认只要是错误都需要重试


/**
 * 创建axios对象
 **/
let axiosInstance = axios.create({
    withCredentials: true,
});
/**
 * 访问请求拦截(在请求前处理)
 **/
axiosInstance.interceptors.request.use(
    function (config) {


        var user_token = store.getters.getToken.token
        axios.defaults.headers.common['user_token'] = user_token;
        config.headers.common['user_token'] = user_token;

        return config;
    },
    function (error) {
        return Promise.reject(error)
    }
);

/**
 * 响应请求拦截(在响应前处理)
 **/
axiosInstance.interceptors.response.use(
    function (response) {
    },
    function (error) {
    }
);

export function getCookie(c_name) {
    //判断document.cookie对象里面是否存有cookie
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=")
        //如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1
            var c_end = document.cookie.indexOf(";", c_start)
            if (c_end == -1) c_end = document.cookie.length
            return unescape(document.cookie.substring(c_start, c_end))
        }
    }
    return ""
}
/* 封装get方法*/
export function get(url, data) {
    var url = config.baseURL + url;
    return new Promise((resolve, reject) => {
        axios.get(url, data)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            })
    })
}

/* 封装post方法 */
export function post(url, data) {
    var url = config.baseURL + url;
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(res => {
                console.log(res)
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            })
    })
}

/**
 * 封装http
 * @type {{post: (function({url: String, params: Object, successCallback: Function, failCallback: Function}): Promise<unknown>), get: (function({url: String, params: Object, successCallback: Function, failCallback: Function}): Promise<unknown>)}}
 */
let http = {
    /**
     * 以get方式请求获取JSON数据
     * @param {Object} opts 配置项，可以包含以下成员：
     * @param {String} opts.url 请求地址
     * @param {Object} opts.params 附加的请求参数
     * @param {Function} opts.successCallback 成功的回调函数
     * @param {Function} opts.failCallback 失败的回调函数
     * **/
    get: function (opts) {
        return new Promise((resolve, reject) => {
            axiosInstance
                .get(opts.url, { params: opts.params })
                .then(function (res) {
                    opts.res = res.data;
                    resolve(res.data);
                })
                .catch(function (err) {
                    if (err.response) {
                        if (err.response.data) {
                            opts.res = err.response.data;
                            // httpResponseHandle.call(opts);
                            resolve(res.data);
                        } else {
                            // 统一错误弹出 统一错误页面
                            this.$router.push({
                                path: '/error'
                            })
                        }
                    }
                });
        })
    },

    /**
     * 以post方式请求获取JSON数据
     * @param {Object} opts 配置项，可以包含以下成员：
     * @param {String} opts.url 请求地址
     * @param {Object} opts.params 附加的请求参数
     * @param {Function} opts.successCallback 成功的回调函数
     * @param {Function} opts.failCallback 失败的回调函数
     * **/
    post: function (opts) {
        return new Promise((resolve, reject) => {
            axiosInstance
                .post(opts.url, opts.params)
                .then(function (res) {
                    opts.res = res.data;
                    resolve(res.data);
                })
                .catch(function (err) {
                    if (err.response) {
                        if (err.response.data) {
                            opts.res = err.response.data;
                        } else {
                            // 统一错误弹出
                        }
                    }
                });
        })
    }
};
export default http;
export function upload(data, type) {

}